import {BaseFormModel} from './base-form-model';
import {MenuModifier} from './menu-modifier';

export class OrderItemModifier extends BaseFormModel<OrderItemModifier> {
    id: number;
    menuModifier: MenuModifier;
    additionalPrice: number;
    modifierDisplayPosition: string;
    defaultModifier: boolean;
    groupByModifier: boolean;
    selectionName: string;
    selectionRequired: boolean;
    selectionSortOrder: number;
    sortOrder: number;
    child: boolean;
}
